import React from 'react';

const Footer = () => {
  return (
    <div
      id="footer"
      className="text-center py-8 bg-[linear-gradient(to_bottom,_#777,_#e1e6ea)] text-[#003468] mt-[2px] border-t border-[#eee]"
    >
      <div>
        <section className="relative mb-4">
          <div className="portlet-content">
            <h2 className="hidden">FOOTER</h2>
            <span className="text-[#003468] text-[14px] leading-[1.42857143] font-sans text-center block antialiased">
              Công ty Cổ phần vàng bạc đá quý Phú Nhuận
              <br />
              170E Phan Đăng Lưu, Phường 4, Phú Nhuận, TP.HCM
            </span>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Footer; 